import { PlusOutlined } from "@ant-design/icons"
import { Button, Divider, InputNumber, Select, Space, Typography, message } from "antd"
import React, { useEffect, useRef, useState } from "react"
import { handleCalculate } from "../Calculation/handleCalculate"
import { doc, updateDoc } from "firebase/firestore"
import { db } from "../../firebase/config"

const { Text } = Typography

export default function LabelCount({
  value,
  setValue,
  product,
  setProduct,
  newPriceWithParameters,
  setNewPriceWithParameters,
  drawerLoading,
  buttonSize,
}) {
  const [labelCounts, setAllLabelCounts] = useState([])
  const [countLoading, setCountLoading] = useState(true)
  const [disable, setDisable] = useState(true)

  const [countForCalculate, setCountForCalculate] = useState(0)
  const [priceForCalculate, setPriceForCalculate] = useState(0)

  const [calculateButtonLoading, setCalculateButtonLoading] = useState(false)
  const [disableAddButton, setDisableAddButton] = useState(true)

  const inputRef = useRef(null)

  //filters if there is a weight property
  const filterWeight = (p) => {
    return {
      price: p.price,
      quantity: p.quantity,
      labelWeight: p.labelWeight > 0 ? p.labelWeight : 0,
      m2: p.m2,
    }
  }

  useEffect(() => {
    setCountLoading(true)
    //checks if there is product first
    if (product && drawerLoading !== true) {
      //creates empty array
      let labelCountsData = []
      if (product && product.advanced.fixedPrice === true) {
        //executes when product has fixed price
        let obj = { ...product }
        let dynamicFixedPriceWithTotal = obj.dynamicFixedPrice
          ?.map(filterWeight)
          .filter((p) => p.quantity > 0)
        dynamicFixedPriceWithTotal?.push({
          price: obj.totalFixedPrice,
          quantity: obj.labelCount,
          labelWeight: obj.labelWeight,
          m2: obj.m2,
        })
        labelCountsData = dynamicFixedPriceWithTotal
      } else {
        //executes when product has no fixed price
        let obj = { ...product }
        let dynamicPriceWithTotal = obj.dynamicPrice
          ?.map(filterWeight)
          .filter((p) => p.quantity > 0)
        dynamicPriceWithTotal?.push({
          price: obj.price,
          quantity: obj.labelCount,
          labelWeight: obj.labelWeight,
          m2: obj.m2,
        })
        labelCountsData = dynamicPriceWithTotal
      }

      //fixed tag
      const tagElement = product && product.advanced.fixedPrice ? "fixed" : "dynamic"

      // Modify this section
      const updatedLabelCounts = labelCountsData.map((item) => ({
        ...item,
        label: `Price : ${item.price} | Quantity : ${item.quantity} | ${tagElement}`,
        value: item.quantity,
      }))
      //setsData
      setAllLabelCounts(updatedLabelCounts)
      setDisable(false)
    } else {
      //disables button
      setDisable(true)
    }
    //disables loading
    setCountLoading(false)
  }, [product, drawerLoading])

  //updates changes
  const handleChange = (value, option) => {
    console.log(option)
    //sets value back to parrent
    setValue({
      price: Number(option.price),
      quantity: Number(option.quantity),
      labelWeight: Number(option.labelWeight),
      m2: Number(option.m2),
    })
  }

  //finds the closes price across all prices
  const findClosestPrice = () => {
    if (countForCalculate !== null && labelCounts.length > 0) {
      let closestObj = labelCounts.reduce((prev, curr) => {
        return Math.abs(curr.quantity - countForCalculate) <
          Math.abs(prev.quantity - countForCalculate)
          ? curr
          : prev
      })

      return closestObj.price
    }

    return null
  }

  //handles the input of count for fixed and dynamic price
  const handleCalculationCount = (value) => {
    setCountForCalculate(value)
  }

  //calculates new price
  const calculateItem = async (e) => {
    e.preventDefault()
    setCalculateButtonLoading(true)

    try {
      //results of the handleCalculate response
      const result = await handleCalculate(product, countForCalculate)

      console.log(product)

      //if fixed price
      if (product && product.advanced.fixedPrice) {
        //finds the closest number from previous prices
        const closestFixedPrice = findClosestPrice()
        findClosestPrice()
        //creats a new object with the price and calculation results
        const newPriceObject = {
          cenaPar1000uzlimemEur: closestFixedPrice,
          tiraisSvarsKg: result.tiraisSvarsKg,
          papiraPaterins: result.papiraPaterins,
          totalCount: countForCalculate,
        }
        //sets the value of the price input
        setPriceForCalculate(closestFixedPrice)

        //sets the whole object
        setNewPriceWithParameters(newPriceObject)
      } else {
        //if dynamic price
        setNewPriceWithParameters(result)
        setPriceForCalculate(result.cenaPar1000uzlimemEur)
      }
    } catch (error) {
      message.error("Could not calculate")
      console.log(error)
    } finally {
      setCalculateButtonLoading(false)
    }
  }

  //toggles add button disable state
  //also allows add button if the price is fixed
  useEffect(() => {
    if (product && product.advanced.fixedPrice) {
      if (
        countForCalculate <= 0 ||
        priceForCalculate <= 0 ||
        newPriceWithParameters.papiraPaterins <= 0 ||
        newPriceWithParameters.tiraisSvarsKg <= 0
      ) {
        setDisableAddButton(true)
      } else {
        setDisableAddButton(false)
      }
    } else {
      if (
        newPriceWithParameters.cenaPar1000uzlimemEur <= 0 ||
        newPriceWithParameters.totalCount <= 0
      ) {
        setDisableAddButton(true)
      } else {
        setDisableAddButton(false)
      }
    }
  }, [newPriceWithParameters, product, countForCalculate, priceForCalculate])

  //checks which price to add
  const savePrice = async () => {
    if (product && product.advanced.fixedPrice) {
      await addNewFixedPrice()
    } else {
      await addNewPrice()
    }
  }

  //adds the new price
  const addNewPrice = async () => {
    setDisableAddButton(true)

    const ref = doc(db, "priceCalculation", product.id)
    //gets the existing array of price
    const oldPrices = product.dynamicPrice

    //translates the new price to match the existing onces
    const transformedPrice = {
      price: newPriceWithParameters.cenaPar1000uzlimemEur,
      labelWeight: newPriceWithParameters.tiraisSvarsKg,
      m2: newPriceWithParameters.papiraPaterins,
      quantity: newPriceWithParameters.totalCount,
    }

    //joins them in array
    const newPrice = [...oldPrices, transformedPrice]

    //updates into a database
    try {
      updateDoc(ref, {
        dynamicPrice: newPrice,
      }).then(() => {
        message.success("New price added!")

        //resets state
        setCountForCalculate(0)
        setPriceForCalculate(0)
        setNewPriceWithParameters({})
        setDisableAddButton(true)
        // //updates new label counts
        setProduct((prevState) => ({
          ...prevState,
          dynamicPrice: newPrice,
        }))
      })
    } catch (error) {
      console.log(error.message)
      message.error(error)
    } finally {
      setDisableAddButton(false)
    }
  }

  //add fixed price
  const addNewFixedPrice = async () => {
    setDisableAddButton(true)

    const ref = doc(db, "priceCalculation", product.id)
    //gets the existing array of price
    const oldPrices = product.dynamicFixedPrice

    //translates the new price to match the existing onces
    //takes the newPrice from parent because of the updates of the new price from product selection
    const transformedPrice = {
      price: newPriceWithParameters.cenaPar1000uzlimemEur,
      labelWeight: newPriceWithParameters.tiraisSvarsKg,
      m2: newPriceWithParameters.papiraPaterins,
      quantity: newPriceWithParameters.totalCount,
    }

    //joins them in array
    const newPrice = [...oldPrices, transformedPrice]

    //updates into a database
    try {
      updateDoc(ref, {
        dynamicFixedPrice: newPrice,
      }).then(() => {
        message.success("New price added!")

        //resets state
        setCountForCalculate(0)
        setPriceForCalculate(0)
        setNewPriceWithParameters({})
        setDisableAddButton(true)
        // //updates new label counts
        setProduct((prevState) => ({
          ...prevState,
          dynamicFixedPrice: newPrice,
        }))
      })
    } catch (error) {
      console.log(error.message)
      message.error(error)
    } finally {
      setDisableAddButton(false)
    }
  }

  //style for select fields
  const style = { width: "100%" }
  return (
    <>
      <Select
        disabled={disable}
        showSearch
        loading={countLoading}
        onChange={handleChange}
        value={value && value.quantity}
        style={style}
        size={buttonSize}
        placeholder="Select label count"
        optionFilterProp="children"
        filterSort={(a, b) => a.value - b.value}
        options={labelCounts}
        dropdownRender={(menu) => (
          <>
            {menu}
            <Divider
              style={{
                margin: "8px 0",
              }}
            />
            <Space
              style={{
                padding: "0 8px 4px",
              }}>
              <Text>Q :</Text>
              <InputNumber
                size="small"
                placeholder="Please enter item"
                value={countForCalculate}
                ref={inputRef}
                onChange={handleCalculationCount}
              />
              <Text>P :</Text>

              <InputNumber size="small" disabled value={priceForCalculate} />

              <Button
                size="small"
                type="primary"
                disabled={calculateButtonLoading}
                onClick={calculateItem}>
                {product && product.advanced.fixedPrice ? "Verify" : "Calc."}
              </Button>

              <Divider type="vertical" />
              <Button
                disabled={disableAddButton}
                size="small"
                onClick={() => savePrice()}
                icon={<PlusOutlined />}>
                Add
              </Button>
            </Space>
          </>
        )}
      />
    </>
  )
}
